import React from 'react';
import PropTypes from 'prop-types';
import { APARTMENTS, SALE } from '../../../../../consts';

function MoreProperty (props) {
  const item = props.item;
  const property = item.getProperty();
  const room = property.getRoom();
  const planing = room.getPlanning();
  const balcony = room.getBalcony();
  const building = property.getBuilding();
  const infrastructure = property.getInfrastructure();
  const dealCondition = item.getDealCondition();

  const furniture = room.getFurniture();
  const buildingType = building.getType();

  const renderSaleApartment = () => {
    return [
      (dealCondition.isClearSale() && 'ч/пр'),
      (dealCondition.isExchange() && 'обмен'),
      (dealCondition.isMortgage() && 'ип'),
      (building.isNewBuilding() && 'нов'),
      building.getDeliveryDateLabel(),
      (planing && planing.get('shortName')),
      (balcony && balcony.get('id') > 0 && 'б/л')
    ].filter(Boolean).join(', ');
  };

  const renderDefault = () => {
    return [
      (buildingType && buildingType.get('middleName')),
      building.getLabelFirstLine(),
      room.getLabelPrivateEntrance(),
      infrastructure.getLabelSecurityProtection(),
      building.getLabelRepairPit(),
      building.getLabelCellar(),
      building.getLabelElectricity(),
      building.getLabelHeating(),
      building.getLabelWater(),
      building.getLabelCanalization(),
      building.getLabelNewBuilding(),
      building.getDeliveryDateLabel(),

      room.getLabelNumberOfBeds(),
      (furniture && furniture.get('shortName')),
      room.getLabelPhone(),
      room.getLabelFridge(),
      room.getLabelTV(),
      room.getLabelWashingMachine(),
      room.getLabelConditioning(),
      dealCondition.getLabelAnimalsAllow(),

      building.getLabelDetached()
    ].filter(Boolean).join(', ');
  };

  return (
    <td className='paper col-building'>
      <div>
        { item.getDealType() === SALE && item.getRealtyType() === APARTMENTS ? renderSaleApartment() : renderDefault() }
      </div>
    </td>
  );
}

MoreProperty.propTypes = {
  item: PropTypes.object.isRequired
};

MoreProperty.defaultProps = {};

export default MoreProperty;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/PaperCells/MoreProperty.jsx